import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { ExclamationTriangle, GeoAlt, Files, ArrowUpRightCircle, MenuButton } from 'react-bootstrap-icons';
import { getFullAddress } from '../../../helpers/global';
import UnderlineButton from '../../UnderlineButton';
import CircularProgressBar from '../../common/circular-progress';

const LoadingServiceCard = ({ service, onReloadClick }) => {
  return (
    <div style={{ backgroundColor: '#fafafa' }}>
      <div className="mt-2 mb-2 px-2 px-md-5 py-4">
        <div className="pt-0">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4 gap-1">
            <div className="d-flex mb-2 mb-md-0">
              <div className="mr-1">
                <div className="mr-1 d-flex align-items-center">
                  <div className="ml-1 mr-2 font-weight-bold text-dark xxlargeFont">
                    <div
                      className="shimmer"
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                  <div className="ml-1 mr-2 font-weight-bold text-dark xxlargeFont">
                    <div
                      className="shimmer"
                      style={{
                        width: '300px',
                        height: '32px',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <div
                className="shimmer"
                style={{ width: '60px', height: '32px', borderRadius: '4px', marginRight: '8px' }}
              />
              <div
                className="shimmer"
                style={{ width: '80px', height: '32px', borderRadius: '4px', marginRight: '8px' }}
              />
              <div className="shimmer" style={{ width: '100px', height: '32px', borderRadius: '4px' }} />
            </div>
          </div>

          <div className="mt-1 px-8">
            <div className="py-4">
              <div className="row g-3 justify-content-between" style={{ gap: '1rem 0rem' }}>
                {[...Array(8)].map((_, index) => (
                  <div key={index} className="col-md-3 col-12">
                    <div
                      className="shimmer"
                      style={{
                        height: '60px',
                        borderRadius: '8px',
                        width: '100%'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="py-2">
            <div className="d-flex mt-5 mb-3" style={{ gap: '1rem' }}>
              <div className="shimmer" style={{ width: '120px', height: '40px', borderRadius: '8px' }} />
              <div className="shimmer" style={{ width: '120px', height: '40px', borderRadius: '8px' }} />
              <div className="shimmer" style={{ width: '120px', height: '40px', borderRadius: '8px' }} />
            </div>
            <div className="border rounded p-3">
              <div className="d-flex flex-column" style={{ gap: '1rem' }}>
                <div className="row g-3 mt-2" style={{ gap: '1rem 0' }}>
                  {[...Array(6)].map((_, index) => (
                    <div key={index} className="col-md-4 col-12">
                      <div className="shimmer" style={{ height: '60px', borderRadius: '8px', width: '100%' }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 text-center">
            {service?.loadingError && (
              <>
                <ExclamationTriangle className="text-danger" size={24} />
                <UnderlineButton
                  fontSize="smallFont"
                  className="my-2"
                  onClick={onReloadClick}
                  variant="dark"
                  text={'Something went wrong click here to try again'}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingServiceCard;
